import RedeemSchoolGiftSubscriptionFlow from "@pathwright/web/src/modules/subscription/redeem-school-gift-subscription-flow/RedeemSchoolGiftSubscriptionFlow"
import { createCardRoutes } from "lib/core/routing/card-routing"
import FallbackComponent from "store/StoreOrLibraryBrowse"

export default createCardRoutes(
  "/",
  {
    redeem: {
      component: RedeemSchoolGiftSubscriptionFlow
    }
  },
  FallbackComponent
)
